/* ============================================================
   SURO — Juego one-shot landing.
   Carrito real (form → suro-cart.js). Solo UI: qty, postal, gallery, faq, bar.
   ============================================================ */
(function(){
  'use strict';
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  if(!$('#osForm')) return;

  const qtyInput = $('#osQtyInput');
  const unit = parseInt(qtyInput.dataset.unit || '0', 10); // céntimos
  const euro = c => (c/100).toLocaleString('es-ES',{minimumFractionDigits:2,maximumFractionDigits:2}) + '€';
  let qty = 1;

  function updateQty(){
    qty = Math.max(1, Math.min(9, qty));
    qtyInput.value = qty;
    const valEl = $('#qtyVal'); if(valEl) valEl.textContent = qty;
    $$('[data-total-out]').forEach(el=> el.textContent = euro(unit * qty));
    const hint = $('#qtyHint'); if(hint) hint.style.display = qty > 1 ? 'inline' : 'none';
  }

  /* qty stepper */
  document.addEventListener('click', e=>{
    if(e.target.closest('[data-qplus]')){ qty++; updateQty(); }
    if(e.target.closest('[data-qminus]')){ qty--; updateQty(); }
    if(e.target.closest('[data-scroll-buy]')){ const f=$('#osForm'); if(f) f.requestSubmit(); }
  });

  /* postal personalization */
  const ta = $('#postalMsg'), pc = $('#postalCard'), toggle = $('#personalToggle');
  if(toggle){
    toggle.addEventListener('click', ()=>{
      const box = toggle.closest('.os-personal');
      const collapsed = box.classList.toggle('collapsed');
      toggle.setAttribute('aria-expanded', String(!collapsed));
    });
  }
  if(ta){
    ta.addEventListener('input', ()=>{
      const val = ta.value.slice(0,140);
      const mc = $('#msgCount'); if(mc) mc.textContent = val.length + '/140';
      if(pc){
        if(val.trim()){ pc.textContent = '“'+val.trim()+'”'; pc.classList.remove('empty'); }
        else { pc.textContent = 'Tu mensaje aparecerá aquí… escríbelo abajo ✍️'; pc.classList.add('empty'); }
      }
      // Solo añade la propiedad al carrito si hay texto
      if(val.trim()) ta.setAttribute('name','properties[Mensaje postal]');
      else ta.removeAttribute('name');
    });
  }

  /* FAQ */
  $$('.faq__q').forEach(q=> q.addEventListener('click', ()=>{
    const item = q.closest('.faq__item');
    item.classList.toggle('open');
  }));

  /* sticky bar */
  const bar = $('#osBar'), anchor = $('#buyAnchor');
  if(bar && anchor && 'IntersectionObserver' in window){
    new IntersectionObserver(es=>{ es.forEach(en=> bar.classList.toggle('show', !en.isIntersecting)); }, {threshold:0}).observe(anchor);
  }

  updateQty();
})();
